import React from 'react'
import { Pressable, StyleProp, TextStyle, View } from 'react-native'
import { Text, ActivityIndicator } from 'react-native-paper'
import { useTheme } from '../../hooks/theme.hook'

export interface LinkProps {
  text: string
  onPress?: () => void
  style?: StyleProp<TextStyle>
  disabled?: boolean
  isLoading?: boolean
}

export function Link({
  text,
  onPress,
  style,
  disabled = false,
  isLoading = false,
}: LinkProps) {
  const theme = useTheme()

  const linkStyle: StyleProp<TextStyle> = {
    color: disabled ? theme.colors.onSurfaceDisabled : theme.colors.primary,
    opacity: disabled ? 0.6 : 1,
  }

  if (isLoading) {
    return (
      <View style={linkStyle}>
        <ActivityIndicator size="small" color={theme.colors.primary} />
      </View>
    )
  }
  if (!onPress) {
    return <Text style={[linkStyle, style]}>{text}</Text>
  }

  return (
    <Pressable
      onPress={disabled || isLoading ? undefined : onPress}
      style={({ pressed }) => [
        {
          opacity: pressed && !disabled && !isLoading ? 0.7 : 1,
          flexDirection: 'row',
          alignItems: 'center',
          gap: 8,
        },
      ]}
    >
      <Text style={[linkStyle, style]}>{text}</Text>
    </Pressable>
  )
}
